
import { IRouteItem } from '../router.d';

export interface IRouteList {
  request: IRouteItem;
  status: IRouteItem;
  consent: IRouteItem;
  terms: IRouteItem;
  consentsuccess: IRouteItem;
  sendrequest: IRouteItem;
  confirmsuccess: IRouteItem;
  dashboardloading: IRouteItem;
  medpending: IRouteItem;
  executionstatus: IRouteItem;
  checkuser: IRouteItem;
  login: IRouteItem;
  dashboardinsurance: IRouteItem;
  requestlist: IRouteItem;
  requeststatus: IRouteItem;
  requestedhistory: IRouteItem;
  medpendingweb: IRouteItem;
  medsuccessweb: IRouteItem;
  newpasswordlogin: IRouteItem;
  NewPasswordexpiredcode: IRouteItem;
  choiceforgetpassword: IRouteItem;
  setnewpassword: IRouteItem;
  setforgetpasswordemail: IRouteItem;
  setforgetpasswordphone: IRouteItem;
  manageuser: IRouteItem;
  newpasswordloginUser: IRouteItem;
  logindashboardmedical: IRouteItem;
  dashboardMedical: IRouteItem;
  manageData: IRouteItem;
  dashboardsuperadmin: IRouteItem;

}

const link = '/';

const Route: IRouteList = {
  // logintype: {
  //   link: `${link}login-type`,
  //   name: 'logintype',
  // },
  dashboardinsurance: {
    link: `${link}dashboard-insurance`,
    name: 'dashboard',
  },
  login: {
    link: `${link}login`,
    name: 'Login',
  },
  logindashboardmedical: {
    link: `${link}login-dashboard-medical`,
    name: 'logindashboardmedical',
  },
  dashboardMedical: {
    link: `${link}dashboard-medical`,
    name: 'dashboardMedical',
  },
  manageData: {
    link: `${link}manage-data`,
    name: 'manageData',
  },
  status: {
    link: `${link}status`,
    name: 'status',
  },
  consent: {
    link: `${link}consent`,
    name: 'consent',
  },
  consentsuccess: {
    link: `${link}consent-success`,
    name: 'consentsuccess',
  },
  terms: {
    link: `${link}terms`,
    name: 'terms',
  },
  sendrequest: {
    link: `${link}send-request`,
    name: 'sendrequest',
  },
  confirmsuccess: {
    link: `${link}confirm-success`,
    name: 'confirmsuccess',
  },
  dashboardloading: {
    link: `${link}`,
    name: 'dashboardloading',
  },
  checkuser: {
    link: `${link}check-user`,
    name: 'checkuser',
  },
  medpending: {
    link: `${link}medical-pending`,
    name: 'medpending',
  },
  executionstatus: {
    link: `${link}execution-status`,
    name: 'executionstatus',
  },
  requestlist: {
    link: `${link}request-list`,
    name: 'requestlist',
  },
  request: {
    link: `${link}request`,
    name: 'request',
  },
  requeststatus: {
    link: `${link}request-status`,
    name: 'requeststatus',
  },
  requestedhistory: {
    link: `${link}requested-history`,
    name: 'requestedHistory',
  },
  medpendingweb: {
    link: `${link}medical-pendingweb`,
    name: 'medpendingweb',
  },
  medsuccessweb: {
    link: `${link}medical-success-web`,
    name: 'medsuccessweb',
  },
  newpasswordlogin: {
    link: `${link}newpassword-login`,
    name: 'newpasswordlogin',
  },
  NewPasswordexpiredcode: {
    link: `${link}newpassword-expiredcode`,
    name: 'NewPasswordexpiredcode',
  },
  choiceforgetpassword: {
    link: `${link}choice-forget-password`,
    name: 'choiceforgetpassword',
  },
  setnewpassword: {
    link: `${link}set-newpassword`,
    name: 'setnewpassword',
  },
  setforgetpasswordemail: {
    link: `${link}set-forgetpassword-email`,
    name: 'setforgetpasswordemail',
  },
  setforgetpasswordphone: {
    link: `${link}set-forgetpassword-phone`,
    name: 'setforgetpasswordphone',
  },
  newpasswordloginUser: {
    link: `${link}newpassword-login-user`,
    name: 'newpasswordloginUser',
  },
  manageuser: {
    link: `${link}manage-user`,
    name: 'manageuser',
  },
  dashboardsuperadmin: {
    link: `${link}dashboard-superadmin`,
    name: 'dashboardsuperadmin',
  }
};

export default Route;
